const ActiveIconSvg = ({
  height = 24,
  width = 24,
  viewBox = '0 0 24 24',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M23 12C23 18.075 18.075 23 12 23C5.925 23 1 18.075 1 12C1 5.925 5.925 1 12 1C18.075 1 23 5.925 23 12ZM9.305 18.11L18.707 8.707L17.293 7.293L9.41 15.176L6.934 12.166L5.423 13.476L9.305 18.109V18.11Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default ActiveIconSvg;
